import { Activity, CheckCircle2, Server } from "lucide-react";


export const ServerSidePanel = ({ servers, selectedServer, recommendedServerId, onSelect }) => (
  <aside className="border border-slate-800 bg-slate-900/60 p-4 rounded-lg lg:sticky lg:top-6" data-testid="smart-server-panel">
    <div className="mb-4">
      <p className="text-xs font-semibold uppercase text-cyan-400">Smart placement</p>
      <h2 className="mt-1 text-base font-semibold text-slate-100">Target server</h2>
      <p className="mt-1 text-xs text-slate-400">Recommendations favor online nodes with the lowest managed-domain load.</p>
    </div>
    <div className="space-y-2">
      {servers.map((server) => {
        const recommended = server.id === recommendedServerId;
        const active = server.id === selectedServer;
        return (
          <button key={server.id} type="button" onClick={() => onSelect(server.id)} className={`w-full border p-3 text-left rounded-md transition-colors ${active ? "border-cyan-500 bg-cyan-950/30" : "border-slate-800 bg-slate-950/50 hover:border-slate-700"}`} data-testid={`server-recommendation-${server.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="flex items-center gap-2 truncate text-sm font-semibold text-slate-100"><Server className="h-4 w-4 text-cyan-400" />{server.name}</p>
                <p className="mt-1 font-mono text-xs text-slate-500">{server.ip_address}</p>
              </div>
              {recommended && <span className="border border-emerald-500/25 bg-emerald-500/10 px-2 py-1 text-xs text-emerald-300 rounded-md" data-testid={`recommended-server-${server.id}`}>Recommended</span>}
            </div>
            <div className="mt-3 flex items-center justify-between text-xs">
              <span className={server.is_online ? "text-emerald-300" : "text-rose-300"}><Activity className="mr-1 inline h-3.5 w-3.5" />{server.is_online ? "Online" : "Offline"}</span>
              <span className="font-mono text-slate-300">{server.domain_count} domains</span>
            </div>
            <p className="mt-2 text-xs text-slate-500">{server.recommendation_reason}</p>
            {active && <p className="mt-2 flex items-center gap-1 text-xs text-cyan-300"><CheckCircle2 className="h-3.5 w-3.5" />Selected target</p>}
          </button>
        );
      })}
    </div>
  </aside>
);